import { bookingCalendarHref, type BookingCtaSurface } from "@/lib/contact-links";
import { getMainLayoutMessages } from "@/lib/content/entries/shared-chrome";
import type { AppLocale } from "@/lib/i18n/constants";

type PrimaryBookingCtaOptions = {
  campaign?: string;
  content: string;
  medium: BookingCtaSurface;
};

export type PrimaryBookingCta = {
  href: string;
  label: string;
  shortLabel: string;
};

export function getPrimaryBookingCta(
  locale: AppLocale,
  { campaign = "primary_cta_system", content, medium }: PrimaryBookingCtaOptions,
): PrimaryBookingCta {
  const chrome = getMainLayoutMessages(locale);

  return {
    href: bookingCalendarHref({ campaign, content, medium }),
    label: chrome.navContactCta,
    shortLabel: chrome.navContactCtaShort,
  };
}
